module.exports = __webpack_public_path__ + "img/e13.44a6291c.jpg";